<template>
    <div >
      <MdTitle v-bind:Text="$t('DrugsMovementRep.ReportTitle')" />
      <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input 
                        type="text" 
                        class="form-control"
                        :dir="dirInput"
                        v-model="parameter.SearchCriteria"   
                          @keyup.enter="LoadDrugsMovement"                            
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton 
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="LoadDrugsMovement">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      
      <b-row>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.datefrom')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'datefrom'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateFrom"
              v-bind:isRequired="false">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdEdit 
              v-bind:Label="$t('Shared.dateTo')"
              v-bind:TypeProp="'date'" 
              v-bind:Name="'dateto'"
              v-bind:Min="'1900-01-01'"
              v-bind:Max="'2200-12-31'"
              v-model="dateTo"
              v-bind:isRequired="false">                                     
            </MdEdit>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$tc('Shared.Patient',2)"
              v-bind:Options="PatientsList"
              v-bind:Model="PatientCodeModel"
              v-bind:FieldDescription="'patientName'"
              v-bind:FieldCode="'patientcode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownPatients"
              :CustomLabel="customLabelPatients"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDropDownDrugs"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeDropDownLoc"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('Shared.DrugType')"
              v-bind:Options="DrugTypeOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="DrugTypeModel"  
              :Input="ChangeDrugType"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdSelect
              v-bind:Label="$tc('DrugsMovementRep.Trans')"
              v-bind:Options="TranOptions"
              v-bind:FieldDescription="'name'"
              v-bind:FieldCode="'value'"
              v-bind:AllowEmpty="true"
              v-bind:Multiple="true"
              v-bind:Model="TranModel"  
              :Input="ChangeTran"/>
          </b-col>
          <b-col lg="3" md="3" sm="12">
            <MdRadioGroup
              v-bind:Label="$t('ChartReview.OrderBy')"
              v-model="order"
              v-bind:Options="orderOptions"
              v-bind:Name="'order'"
            />
          </b-col>
          <b-col lg="9" md="9" sm="12"></b-col>
          <b-col lg="3" md="3" sm="12">
            <div class="text-md-right mt-3">
                <button 
                    v-on:click="LoadDrugsMovement"
                    type="button"
                    class="btn btn-primary btn-login mx-2"												
                    id="btnsearchinput">
                    {{ $t('Shared.Search') }}
                </button>
            </div>
          </b-col> 
     
        </b-row>
        <div class="row">
          <div class="col-12 mt-2">
             <MdTitle  v-bind:Text="$t('Shared.SearchResult')" 
                          v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <div class="row">
              <div class="col-md-12">
                  <MdTable 
                    v-bind:fields="fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    v-bind:refTable="refTable"
                    :pageChanged="pageChanged"
                    :perPageFunction="PerPageFunction"
                    v-bind:FieldsDate="FieldsDateArr">
                  </MdTable>
              </div>
            </div>
          </div>
        </div>
        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>   
        </div>

      
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('DrugsMovementRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="reportDrugsMovementFilters"
          :ReportName="'DrugsMovement'"
          :ReportTitle="$t('DrugsMovementRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>

    <CSVExportHelper
        ref="csvExportHelper"
        v-bind:conformSubject="$t('DrugsMovementRep.ReportTitle')"
        v-bind:sendEmailAPI="'/Drugs/Movement/email'"
        v-bind:exportCsvAPI="'/Drugs/Movement/exportCSV'"
    >    
    </CSVExportHelper>
    </div>
</template>

<script>
  import Vue from 'vue'
  import { DxPopup } from 'devextreme-vue/popup';
  import DrugService from '@/services/drug.service'
  import ShowMessage from '@/components/messages/ShowMessage.js'
  import LocationService from '@/services/epharmacylocation.service'
  import DBFunctions from '@/common/DBFunctions.js'
  import PatientService from '@/services/patient.service'
  import { EventBus } from '@/event-bus.js';
  import UtilsService from '@/services/utils.service'
  import Utils from '@/common/utils'

  export default Vue.extend({
      name: "DrugsMovementRep",
      mixins: [ ShowMessage, DBFunctions ],
      components: { DxPopup },
      data() {
          return {
              isParamVisible: true,
              isReportVisible: false,
              dateFrom: null,
              dateTo: null,
              reportParams: [],
              DrugList:[],
              PatientsList: [],
              PatientCodeModel: '',
              DrugsCodeModel:'',
              LocCodeModel:'',
              LocList:[],
              parameter:{
                SearchCriteria:'',
                PageNumber : 0,
                PageSize:0       
              },
              params: {
                DrugList: '',
                PatientCode: '',
                DrugType: '',
                LocList:'',
                Tran: ''
              },
              DrugTypeModel: '',
              DrugTypeOptions: [
                {"value":"C","name":"C"},
                {"value":"CD","name":"CD"},
                {"value":"G","name":"G"},
                {"value":"SCD","name":"SCD"}
              ],
              TranModel: '',
              TranOptions: [
                {"value":"ISSUED","name":this.$t('DrugsMovementRep.ISSUED')},
                {"value":"RECEIVED","name":this.$t('Shared.RECEIVED')},
                {"value":"RELOCATION","name":this.$t('DrugsMovementRep.RELOCATION')},
                {"value":"RETURNED","name":this.$t('DrugsMovementRep.RETURNED')}
              ],
              orderOptions: [
                { value: '', text: this.$t('Shared.Date') },
                { value: 'DN', text: this.$t('drug.Drugname') },
                { value: 'TR', text: this.$t('DrugsMovementRep.Trans') }
              ],
              order: '',
              items: [],         
              fields: [
                { key: 'Trans', sortable: true, label: this.$t('DrugsMovementRep.Trans'), class: 'text-center' },
                { key: 'TransDate', sortable: true, label: this.$t('DrugsMovementRep.TransDate'), class: 'text-center' },
                { key: 'DrugCode', sortable: true, label: this.$t('DrugsMovementRep.DrugCode'), class: 'text-left' },
                { key: 'DrugName', sortable: true, label: this.$t('DrugsMovementRep.DrugName'), class: 'text-left' },
                { key: 'Quantity', sortable: true, label: this.$t('DrugsMovementRep.Quantity'), class: 'text-left' },
                { key: 'UserName', sortable: true, label: this.$t('DrugsMovementRep.UserName'), class: 'text-left' },
                { key: 'Destination', sortable: true, label: this.$t('DrugsMovementRep.Destination'), class: 'text-left' },
                { key: 'NameLocationFrom', sortable: true, label: this.$t('DrugsMovementRep.NameLocationFrom'), class: 'text-left' }
              ],
              pageOptions: [5, 10, 15 ],
              totalRows: 0,
              currentPage: 1,
              perPage: 10,
              selected: [],
              Header:{},
              refTable: 'selectableTable', 
              ShowMessageIsEmpty:true,
              FieldsDateArr:['dateFrom','dateTo'],
              dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',   
          }
      },
      methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
          },

          ChangeDropDownDrugs(values) {
            var drugs = '';
            if (values && values.length > 0) {
                drugs = values.map(x => x.drugCode).join(',');
            }
            this.params.DrugList = drugs; 
          },
          
          
          ChangeTran(values) {
            var trans = '';
            if (values && values.length > 0) {
                trans = values.map(x => x.value).join(',');
            }
            this.params.Tran = trans; 
          },

          ChangeDrugType(values) {
            var drugT = '';
            if (values && values.length > 0) {
                drugT = values.map(x => x.value).join(',');
            }
            this.params.DrugType = drugT; 
          },

          ChangeDropDownPatients(values) {
            var pCodes = '';
            if (values && values.length > 0) {
                pCodes = values.map(x => x.patientcode).join(',');
            }
            this.params.PatientCode = pCodes; 
          },

          customLabelPatients ({ PatientName, patientcode }) {
            return `${PatientName} – ${patientcode}`
          },

          ChangeDropDownLoc(values) {
            var locList = '';
            if (values && values.length > 0) {
                locList = values.map(x => x.code).join(',');
            }
            this.params.LocList = locList; 
          },

          getPatients(){   
            const params = {
              SearchCriteria: '',
            }
            PatientService.getAll(params)
              .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0) {
                this.PatientsList = response.data;                 
                this.PatientsList.forEach(function(element) {	
                    element.PatientName = element.firstname + " " + element.lastname;  
                });       
              }       
              })
              .catch(error => {      
                if (!error.response) {
                    // network error
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
                } else {
                    this.showMessage(this.$tc('Msg.Error'),error,"error");
                }
              });    
            },

  
          getDrugs() { 
            const params = {
              SearchCriteria: '',
            }
            DrugService.getAll(params)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.DrugList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },

          getLocations() {
            const params = {
              SearchCriteria: '',
            } 
            LocationService.getAll(params)
            .then((response) => {
              if(response.status == '200' && response.data && response.data.length > 0){
                this.LocList = response.data;
              }
            })
            .catch(error => {
              if (!error.response) {
              // network error
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.RetrieveInformation'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
            });
          },

          onClickClose() {
            this.isParamVisible = false;
          },

          reportList() {
            this.checkExistFavorite('/app/reports/pharmacy');
            this.$router.push({ name: "reportListPharmacy" }).catch(()=>{});
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'pPatientCodeList',paramValue: this.params.PatientCode })
            this.reportParams.push({ paramName: 'pDrugType', paramValue: this.params.DrugType})
            this.reportParams.push({ paramName: 'pTran', paramValue: this.params.Tran})
            this.reportParams.push({ paramName: 'pLocList',paramValue: this.params.LocList })
            this.reportParams.push({ paramName: 'pOrder', paramValue: this.order})
            this.reportParams.push({ paramName: 'pSearchCriteria', paramValue: this.parameter.SearchCriteria})
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            this.isParamVisible = false
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.reportDrugsMovementFilters.buildDocument(this.reportParams)
          },

          LoadDrugsMovement() {
            this.items = [];
            this.currentPage = 1;
            this.parameter.PageNumber = 1;
            this.totalRows = this.items.length;
            this.getListing();
          },

          initializeParameters() {
           
            // Asignaciones condicionales
            this.parameter.DrugList = this.params.DrugList && this.params.DrugList !== '' 
                ? this.params.DrugList 
                : '';
            
            this.parameter.DateFrom = this.dateFrom;
            this.parameter.DateTo = this.dateTo;
            this.parameter.DrugType = this.params.DrugType && this.params.DrugType !== '' 
              ? this.params.DrugType
              : null;
            this.parameter.PatientCodeList = this.params.PatientCode && this.params.PatientCode !== '' 
                ? this.params.PatientCode
                : '';
            this.parameter.Tran = this.params.Tran && this.params.Tran !== '' 
                ? this.params.Tran
                : '';
            this.parameter.LocList = this.params.LocList && this.params.LocList !== '' 
              ? this.params.LocList
              : '';
            this.parameter.order = this.order;
          },

          getListing() {
            this.parameter.PageNumber = this.currentPage;
            this.parameter.PageSize = this.perPage;

            const procedureName = 'sp_iss_LetterTemplateDrugsMovement'; 
            this.initializeParameters();

            const spParameters = {
              SearchCriteria: this.parameter.SearchCriteria,
              DateFrom: this.parameter.DateFrom,
              DateTo: this.parameter.DateTo,
              DrugType: this.parameter.DrugType,
              Locations: this.parameter.LocList,
              Transaction: this.parameter.Tran,
              DrugCode: this.parameter.DrugList,
              PatientCode: this.parameter.PatientCodeList,
              OrderBy: this.parameter.order
            };
            
            const request = {
              procedureName: procedureName,
              parameters: spParameters,
              pageNumber: this.parameter.PageNumber,
              pageSize: this.parameter.PageSize
            };
          
            UtilsService.getExecuteSP(request)
              .then(response => {
                  this.ShowMessageIsEmpty = false;
                  if (response.status == "200" && response.data) {
                      this.items = response.data;
                      this.items.forEach(function(element) {
                        if (element.TransDate)	
                          element.TransDate = Utils.formatterDateToString(element.TransDate); 
                      });

                      let headerString = response.headers["x-pagination"];
                      this.Header = JSON.parse(headerString);
                      this.totalRows = this.Header.TotalCount;
                  }
                  if(this.items.length === 0){
                    this.ShowMessageIsEmpty = true;
                  }
              })
              .catch(error => {
                  this.showResponseErrorMessage(error);
              });
          },
          pageChanged (page) {            
            this.currentPage = page;
            this.getListing();    
          },

          PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            this.getListing();
          },

          handleCSV(action) {
            this.initializeParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportCSV(this.parameter);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailCSV(this.parameter);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },

          handlePdf(action) {
            this.initializePdfParameters();
            switch(action) {
              case 'export':
                this.$refs.csvExportHelper.exportToPdf('DrugsMovement', true, false, this.reportParams);
              break;
              case 'email':
                this.$refs.csvExportHelper.emailPdf('DrugsMovement', true, false, this.reportParams);
              break;
              default:
                console.warn('unknow action:', action);
              break;
            }
          },
      },
      created() {
       
      },

      mounted () {
        this.getPatients();
        this.getDrugs();
        this.getLocations();
        EventBus.$on("ShowWeel", function (isShow) { 
            isShow ? this.$emit('load', true) : this.$emit('load', false);     
        }.bind(this));
      },
  })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
